import { useMemo } from "react";
import { useAppSelector } from "@store";

export const CUSTOMDATA = "dimensions-custom";
export const WALRDATA = "walr";
export const useIsCustomDataProject = () => {
  const { currentProject } = useAppSelector((state) => state.project);
  const isCustomDataProject = useMemo(() => {
    if (!currentProject) return false;
    const { dataSource: { name: dataSourceName } = {} } = currentProject;
    return dataSourceName === CUSTOMDATA;
  }, [currentProject]);

  return {
    isCustomDataProject,
  };
};
